import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { Code, Database, Laptop } from 'lucide-react';

const About = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const highlights = [
    {
      icon: Database,
      label: language === 'de' ? 'Data & BI' : 'Data & BI',
      color: 'cyan'
    },
    {
      icon: Code,
      label: language === 'de' ? 'Web Dev' : 'Web Dev',
      color: 'emerald'
    },
    {
      icon: Laptop,
      label: language === 'de' ? 'IT Solutions' : 'IT Solutions',
      color: 'cyan'
    }
  ];

  return (
    <section id="about" className="brutalist-section">
      <div className="brutalist-container">
        <div data-reveal="out" className="grid md:grid-cols-[0.9fr_1.1fr] gap-10 items-start">
          <div>
            <p className="brutalist-kicker">{t.about.title}</p>
            <h2 className="brutalist-title mt-4">{t.about.subtitle}</h2>
          </div>

          <div className="space-y-6">
            <p className="text-lg leading-relaxed">
              {t.about.intro}
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              <div className="brutalist-card p-6">
                <p className="text-muted-foreground leading-relaxed">{t.about.approach}</p>
              </div>
              <div className="brutalist-card p-6">
                <p className="text-muted-foreground leading-relaxed">{t.about.expertise}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-border pt-10">
          <div className="grid md:grid-cols-3 gap-4">
            {highlights.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  data-reveal="out"
                  style={{ '--reveal-delay': `${index * 70}ms` }}
                  className="brutalist-card p-6 transition-colors duration-100 ease-linear hover:bg-muted hover:border-accent"
                >
                  <div className="flex items-center gap-4">
                    <div className="h-12 w-12 border border-foreground bg-accent text-accent-foreground flex items-center justify-center">
                      <Icon className="w-6 h-6" />
                    </div>
                    <h3 className="font-mono tracking-[0.08em] text-lg font-semibold">{item.label}</h3>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
